import { useParams } from "react-router-dom";
import { CreditControlUnitBreakdownModel } from "services/api/cplapi/CPLAPI";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { createColumnHelper } from "@tanstack/react-table";
import { useEffect } from "react";
import {
  getCreditControlUnitSummaries,
  selectCreditControlUnitSummaries,
  selectLoadingCreditControlUnitSummaries,
} from "./CreditControlUnitSummariesTableSlice";
import { PageDescription } from "_metronic/layout/core";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import CPLTable from "cpl-react-common/components/Tables/CPLTable";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-solid-svg-icons";

const CreditControlUnitSummariesTable: React.FC = () => {
  const { developmentID, statusID } = useParams();
  const thunkDispatch = useThunkDispatch();
  const creditControlUnits = useSelector(selectCreditControlUnitSummaries);
  const loadingCreditControlUnits = useSelector(selectLoadingCreditControlUnitSummaries);

  useEffect(() => {
    thunkDispatch(getCreditControlUnitSummaries({ developmentID: developmentID!, statusID: Number(statusID!) }));
  }, [developmentID, statusID, thunkDispatch]);

  const columnHelper = createColumnHelper<CreditControlUnitBreakdownModel>();
  const columnDefinition = [
    columnHelper.display({
      id: "icon",
      cell: () => (
        <div className="d-flex">
          <FontAwesomeIcon icon={faUser} size="lg" className="cpl-brand-primary" />
        </div>
      ),
      enableHiding: false,
    }),
    columnHelper.accessor((info) => info.propertyAddress, {
      id: "Property Address",
      cell: (info) => info.getValue(),
      header: () => <>Property Address</>,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.amount, {
      id: "Outstanding Balance",
      cell: (info) => info.getValue()!.toGBPString(),
      header: () => <>Outstanding Balance</>,
      enableColumnFilter: false,
      meta: {
        columnClassName: "currency-column-header",
        dataClassName: "text-end",
      },
    }),
  ];
  return (
    <>
      <PageDescription>
        {creditControlUnits.developmentName + " - Status: " + creditControlUnits.status}
      </PageDescription>
      <div className="card d-flex mt-4 cpl-table-container">
        <ActivityIndicator isBusy={loadingCreditControlUnits}>
          <div className="card-body">
            <CPLTable
              data={creditControlUnits.unitBreakdowns}
              columns={columnDefinition}
              classNames="cpl-table-nowrap-below-desktop"
            />
          </div>
        </ActivityIndicator>
      </div>
    </>
  );
};
export default CreditControlUnitSummariesTable;
